// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// ** API Imports
import axios from '@src/service/axios';

import { toast } from 'react-toastify';

export const getWeekendSetting = createAsyncThunk(
  'weekendPolicySliceData/getWeekendSetting',
  async () => {
    try {
      const response = await axios.get('/weekendSetting', {
        headers: { 'Content-Type': 'application/json' }
      });
      return response.data;
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Something went wrong!');
      throw err;
    }
  }
);

export const deleteWeekendSetting = createAsyncThunk('weekendPolicySliceData/deleteWeekendSetting', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/weekendSetting/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'WeekendSetting deleted successfully.');
        await dispatch(getWeekendSetting());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});


export const createWeekendSetting = createAsyncThunk(
  'weekendPolicySliceData/createWeekendPortal',
  async (data, { dispatch }) => {
    try {
      const response = await axios.post('/weekendSetting', data, {
        headers: { 'Content-Type': 'application/json' }
      });
      toast.success(response?.data?.message || 'Settings added successfully.');
      dispatch(getWeekendSetting());
      return response.data.data;
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Something went wrong!');
      throw err;
    }
  }
);

export const updateWeekendSetting = createAsyncThunk('weekendPolicySliceData/updateWeekendSetting', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/weekendSetting/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'WeekendSetting updated successfully.');
        await dispatch(getWeekendSetting());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateWeekendSettingStatus = createAsyncThunk('weekendPolicySliceData/updateWeekendSettingStatus', async (id, { dispatch }) => {
    try {
        let response = await axios.put(
            '/WeekendSetting/status/' + id,
            {},
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        toast.success(response?.data?.message || 'Status Updated Successfully');
        await dispatch(getWeekendSetting());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const getWeekendPolicyOptions = createAsyncThunk('weekendPolicySliceData/getWeekendPolicyOptions', async () => {
    try {
        let response = await axios.get('/weekendSetting?option=true', {  
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }   
});

export const getEmployee = createAsyncThunk('weekendPolicySliceData/getEmployee', async () => {
    try {
        let response = await axios.get('/Employee', {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const bulkAssignWeekendPolicy = createAsyncThunk(
    'weekendPolicySliceData/bulkAssignWeekendPolicy',
    async (data, { dispatch }) => {
        try {
            
            let response = await axios.post('/weekendSetting/assign-weekend-policy', data, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            toast.success(response?.data?.message || 'Weekend policy assigned successfully.');
            await dispatch(getWeekendSetting());
            return Promise.resolve(response);
        } catch (err) {
            toast.error(err?.response?.data?.message || 'Something went wrong!');
            console.log('err', err);
            return Promise.reject(err);
        }
    }
);

export const getAssignedWeekendRuleEmployees = createAsyncThunk('weekendPolicySliceData/getAssignedWeekendRuleEmployees', async (id) => {
    try {
        let response = await axios.get('/WeekendSetting/assigned-employee/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const weekendPolicySlice = createSlice({
    name: 'weekendPolicySliceData',
    initialState: {
        weekendPolicy: [],
        employeeList: [],
        weekendPolicyOptions: []
    },
    extraReducers: (builder) => {
        builder.addCase(getWeekendSetting.fulfilled, (state, action) => {
            state.weekendPolicy = action?.payload;
            return;
        });
        builder.addCase(getEmployee.fulfilled, (state, action) => {
            state.employeeList = action?.payload;
            return;
        });
        builder.addCase(getWeekendPolicyOptions.fulfilled, (state, action) => {
            state.weekendPolicyOptions = action?.payload;
            return;
        });
    }
});

export default weekendPolicySlice.reducer;
